var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	21333: () => (loadSingletonVersion("default", "primeng/config", false, [1,21,1,3], () => (__webpack_require__.e(2746).then(() => (() => (__webpack_require__(/*! primeng/config */ 62746))))))),
	22722: () => (loadSingletonVersion("default", "@angular/core/rxjs-interop", false, [4,21,2,21], () => (__webpack_require__.e(9074).then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 49074))))))),
	31118: () => (loadSingletonVersion("default", "@angular/core", false, [4,21,2,21], () => (__webpack_require__.e(7580).then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))))),
	32838: () => (loadSingletonVersion("default", "@angular/platform-browser/animations/async", false, [4,21,2,21], () => (__webpack_require__.e(9192).then(() => (() => (__webpack_require__(/*! @angular/platform-browser/animations/async */ 39192))))))),
	37361: () => (loadSingletonVersion("default", "@deck.gl/layers", false, [4,9,3,4], () => (__webpack_require__.e(9656).then(() => (() => (__webpack_require__(/*! @deck.gl/layers */ 79656))))))),
	38213: () => (loadSingletonVersion("default", "@deck.gl/mapbox", false, [4,9,3,4], () => (__webpack_require__.e(3311).then(() => (() => (__webpack_require__(/*! @deck.gl/mapbox */ 73311))))))),
	46524: () => (loadSingletonVersion("default", "maplibre-gl", false, [1,6,4,1], () => (__webpack_require__.e(9170).then(() => (() => (__webpack_require__(/*! maplibre-gl */ 59170))))))),
	55883: () => (loadSingletonVersion("default", "rxjs", false, [2,7,8,0], () => (__webpack_require__.e(845).then(() => (() => (__webpack_require__(/*! rxjs */ 80845))))))),
	59150: () => (loadSingletonVersion("default", "@angular/forms", false, [4,21,2,21], () => (__webpack_require__.e(4456).then(() => (() => (__webpack_require__(/*! @angular/forms */ 34456))))))),
	62394: () => (loadSingletonVersion("default", "@angular/common/http", false, [4,21,2,21], () => (__webpack_require__.e(8824).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))))),
	66657: () => (loadSingletonVersion("default", "@cvx/cal-angular", false, [1,21,0,1], () => (__webpack_require__.e(1991).then(() => (() => (__webpack_require__(/*! @cvx/cal-angular */ 71991))))))),
	69700: () => (loadSingletonVersion("default", "@angular/common", false, [4,21,2,21], () => (__webpack_require__.e(7935).then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))))),
	90439: () => (loadSingletonVersion("default", "@angular/platform-browser", false, [4,21,2,21], () => (__webpack_require__.e(8055).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))))),
	92512: () => (loadSingletonVersion("default", "@angular/router", false, [4,21,2,21], () => (__webpack_require__.e(2691).then(() => (() => (__webpack_require__(/*! @angular/router */ 95072))))))),
	76883: () => (loadSingletonVersion("default", "rxjs/operators", false, [2,7,8,0], () => (__webpack_require__.e(8219).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 98219))))))),
	26074: () => (loadSingletonVersion("default", "@angular/core/primitives/di", false, [4,21,2,21], () => (__webpack_require__.e(8513).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 8513))))))),
	97932: () => (loadSingletonVersion("default", "@angular/core/primitives/signals", false, [4,21,2,21], () => (__webpack_require__.e(9080).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 36699))))))),
	14089: () => (loadSingletonVersion("default", "@luma.gl/webgl", false, [4,9,3,4], () => (__webpack_require__.e(672).then(() => (() => (__webpack_require__(/*! @luma.gl/webgl */ 78291))))))),
	14309: () => (loadSingletonVersion("default", "@math.gl/web-mercator", false, [4,9,3,4], () => (__webpack_require__.e(6339).then(() => (() => (__webpack_require__(/*! @math.gl/web-mercator */ 56339))))))),
	26153: () => (loadSingletonVersion("default", "@math.gl/sun", false, [4,9,3,4], () => (__webpack_require__.e(2553).then(() => (() => (__webpack_require__(/*! @math.gl/sun */ 22553))))))),
	61055: () => (loadSingletonVersion("default", "@luma.gl/shadertools", false, [4,9,3,4], () => (__webpack_require__.e(2727).then(() => (() => (__webpack_require__(/*! @luma.gl/shadertools */ 5108))))))),
	86637: () => (loadSingletonVersion("default", "@luma.gl/engine", false, [4,9,3,4], () => (__webpack_require__.e(2207).then(() => (() => (__webpack_require__(/*! @luma.gl/engine */ 94588))))))),
	87225: () => (loadSingletonVersion("default", "@luma.gl/core", false, [4,9,3,4], () => (__webpack_require__.e(5047).then(() => (() => (__webpack_require__(/*! @luma.gl/core */ 75047))))))),
	97409: () => (loadSingletonVersion("default", "@math.gl/core", false, [4,9,3,4], () => (__webpack_require__.e(4642).then(() => (() => (__webpack_require__(/*! @math.gl/core */ 14642))))))),
	76745: () => (loadSingletonVersion("default", "@math.gl/polygon", false, [4,9,3,4], () => (__webpack_require__.e(7433).then(() => (() => (__webpack_require__(/*! @math.gl/polygon */ 37433))))))),
	98513: () => (loadSingletonVersion("default", "@deck.gl/core", false, [4,9,3,4], () => (__webpack_require__.e(8812).then(() => (() => (__webpack_require__(/*! @deck.gl/core */ 6431))))))),
	73487: () => (loadSingletonVersion("default", "@math.gl/types", false, [4,9,3,4], () => (__webpack_require__.e(7608).then(() => (() => (__webpack_require__(/*! @math.gl/types */ 87608))))))),
	50537: () => (loadSingletonVersion("default", "primeng/usestyle", false, [1,21,1,3], () => (__webpack_require__.e(6311).then(() => (() => (__webpack_require__(/*! primeng/usestyle */ 48692))))))),
	40535: () => (loadSingletonVersion("default", "primeng/base", false, [1,21,1,3], () => (__webpack_require__.e(4832).then(() => (() => (__webpack_require__(/*! primeng/base */ 82451))))))),
	76649: () => (loadSingletonVersion("default", "primeng/api", false, [1,21,1,3], () => (__webpack_require__.e(5399).then(() => (() => (__webpack_require__(/*! primeng/api */ 17780))))))),
	77992: () => (loadSingletonVersion("default", "@angular/animations/browser", false, [4,21,2,21], () => (__webpack_require__.e(3036).then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 10655)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"316": [
		31118,
		55883
	],
	"365": [
		31118,
		40535,
		55883,
		69700,
		76649
	],
	"436": [
		31118,
		62394,
		69700
	],
	"655": [
		31118
	],
	"1991": [
		76883
	],
	"2075": [
		31118,
		55883,
		69700,
		76883
	],
	"2207": [
		61055,
		73487,
		87225
	],
	"2451": [
		31118,
		50537
	],
	"2691": [
		76883,
		90439
	],
	"2746": [
		40535,
		76649
	],
	"3311": [
		14309,
		98513
	],
	"4372": [
		31118,
		55883,
		62394,
		69700,
		76883,
		92512
	],
	"4456": [
		76883
	],
	"4588": [
		61055,
		73487,
		87225,
		97409
	],
	"4832": [
		50537
	],
	"5020": [
		21333,
		22722,
		31118,
		32838,
		37361,
		38213,
		46524,
		55883,
		59150,
		62394,
		66657,
		69700,
		90439,
		92512
	],
	"5072": [
		31118,
		55883,
		69700,
		76883,
		90439
	],
	"5108": [
		87225,
		97409
	],
	"6311": [
		69700
	],
	"6339": [
		97409
	],
	"6431": [
		14089,
		14309,
		26153,
		61055,
		86637,
		87225,
		97409
	],
	"6443": [
		31118,
		55883,
		76883
	],
	"6693": [
		26074,
		55883,
		76883,
		97932
	],
	"6811": [
		31118,
		69700
	],
	"7275": [
		14309,
		76745,
		86637,
		97409,
		98513
	],
	"7580": [
		26074,
		55883,
		76883,
		97932
	],
	"7780": [
		31118,
		55883,
		69700
	],
	"7935": [
		55883
	],
	"7992": [
		77992
	],
	"8055": [
		62394
	],
	"8291": [
		87225
	],
	"8692": [
		31118,
		69700
	],
	"8812": [
		14089,
		26153,
		61055,
		86637,
		87225,
		97409
	],
	"8824": [
		55883,
		76883
	],
	"9074": [
		26074,
		76883,
		97932
	],
	"9656": [
		14309,
		76745,
		86637,
		97409,
		98513
	],
	"9814": [
		97409
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}